NtechApp.SerializedCheckboxes = function($wrapper) { 
    var me = this;
    this._click = new NtechApp.TouchClickEvent();

    this._$wrapper = $wrapper;
    this._$hidden = $wrapper.parent().find(
        "[data-customSerializedCheckboxesHiddenId='" + $wrapper.attr("data-customSerializedCheckboxesId") + "']"
    );

    this._hasAllCheckbox = false;
    this._$allCheckbox = this._$wrapper.find("[data-checkboxVal='All']");

    if(this._$allCheckbox.length > 0)
        this._hasAllCheckbox = true;

    this._click.listen($wrapper, "[data-checkboxTrigger]", function(event) {
        var $checkbox = $(event.target).closest("[data-checkboxVal]");

        if(!me._hasAllCheckbox || (me._hasAllCheckbox && $checkbox.attr("data-checkboxVal") != "All")) {
            var $wrapper = $(event.target).closest("[data-customSerializedCheckboxesId]");
            me.selectCheckbox($checkbox, $wrapper);
        }
        else {
            if(me.areAllCheckboxesSelected()) 
                me._unselectCheckboxes();
            else 
                me._selectCheckboxes();

            me._updateHidden();
        }
    });

    return this;
};

NtechApp.SerializedCheckboxes.EVENT_VALUE_CHANGE = "NtechApp.SerializedCheckboxes.EventValueChange";

NtechApp.proto(NtechApp.SerializedCheckboxes, {
    selectCheckbox: function($checkbox, $wrapper) {
        $icon = $checkbox.find(".confirmBox .icon");
        if($icon.hasClass("selectedBox")) {
            $icon.removeClass("selectedBox");
            if(this._hasAllCheckbox)
                this._unselectAllCheckbox();
        }
        else {
            $icon.addClass("selectedBox");
            if(this._hasAllCheckbox && this.areAllCheckboxesSelected())
                this._selectAllCheckbox();
        }

        this._updateHidden();
    },

    getVal: function() {
        var checkboxId = this._$wrapper.attr("data-customSerializedCheckboxesId");
        var $checkboxHidden = this._$wrapper.parent().find("[data-customSerializedCheckboxesHiddenId='" + checkboxId + "']");

        return $checkboxHidden.val();
    },

    updateHidden: function() {
        this._updateHidden();
    },

    _updateHidden: function() {
        var checkboxId = this._$wrapper.attr("data-customSerializedCheckboxesId");
        var $checkboxHidden = this._$wrapper.parent().find("[data-customSerializedCheckboxesHiddenId='" + checkboxId + "']");

        var selectedIds = [];
        var $selectedBoxes = this._$wrapper.find(".selectedBox");

        $.each($selectedBoxes, function() {
            var $checkbox = $(this).closest("[data-checkboxVal]");
            if($checkbox.attr("data-checkboxVal") == "All")
                return true;

            selectedIds.push($checkbox.attr("data-checkboxVal"));
        });

        var serializedIds = selectedIds.join(",");

        $checkboxHidden.val(serializedIds);
        $(this).trigger(NtechApp.SerializedCheckboxes.EVENT_VALUE_CHANGE, [serializedIds, selectedIds]);
    },

    _selectAllCheckbox: function() {
        this._$allCheckbox.find(".confirmBox .icon").addClass("selectedBox");
    },

    _unselectAllCheckbox: function() {
        this._$allCheckbox.find(".confirmBox .icon").removeClass("selectedBox");
    },

    _selectCheckboxes: function() {
        var $checkboxes = this._$wrapper.find("[data-checkboxVal]");
        $.each($checkboxes, function() {
            $(this).find(".confirmBox .icon").addClass("selectedBox");
        });
    },

    _unselectCheckboxes: function() {
        var $checkboxes = this._$wrapper.find("[data-checkboxVal]");
        $.each($checkboxes, function() {
            $(this).find(".confirmBox .icon").removeClass("selectedBox");
        });
    },

    areAllCheckboxesSelected: function() {
        var $checkboxes = this._$wrapper.find("[data-checkboxVal]");
        var areAllSelected = true;

        $.each($checkboxes, function() {
            var val = $(this).attr("data-checkboxVal");
            if(val == "All")
                return true;

            if(!$(this).find(".confirmBox .icon").hasClass("selectedBox"))
                areAllSelected = false;
        });

        return areAllSelected;
    },

    getCheckboxWrapper: function() {
        return this._$wrapper;
    }//,

    // @todo -> Refactor this for serialize
    // val: function(val) {
    //     if(typeof val == "undefined") {
    //         return this._$hidden.val();
    //     }

    //     var $radio = this._$radioWrapper.find("[data-radioVal='" + val + "']");
    //     this.selectRadio($radio, this._$radioWrapper);
    // }
});